<template>
  <v-container fluid class="pa-0">
    <v-sheet ref="vsheet" style="background-color: transparent">
      <v-slide-group v-model="model" class="mx-0" show-arrows="desktop">
        <v-slide-item
          v-for="(item, index) in dataItems"
          :key="index"
          style="width: calc(100vw - 56px); max-width: 360px"
          v-touch="{
            left: (event) => onTouchLeft(event, index),
            right: (event) => onTouchRight(event, index),
          }"
        >
          <div class="ma-2">
            <v-card
              class="rounded-lg pa-0 card-container"
              outlined
              elevation="1"
              style="height: 200px; border: none; overflow: hidden"
              @click="redirectTo(item)"
            >
              <div
                class="w-100 d-flex justify-center align-center"
                style="height: 100%; overflow: hidden"
              >
                <v-img
                  cover
                  class="w-100"
                  style="height: 100%"
                  :lazy-src="require('@/assets/images/image.png')"
                  :src="item.image_url"
                >
                </v-img>
              </div>

              <div class="description-box">
                <p
                  class="description-label title-mission text-start mb-auto text-subtitle-2 white--text"
                >
                  {{ item.name }}
                </p>

                <div
                  v-if="!checkConditionEntryPassFree(item)"
                  class="bottomleft mt-auto mb-0 text-start text-subtitle-2 pl-0 d-flex align-center"
                >
                  <div style="width: 36px; min-width: 36px">
                    <div v-if="item.input_type == 'point'">
                      <PointSymbol
                        v-if="
                          Array.isArray(item.point) && item.point.length > 0
                        "
                        :type="item.point[0].point_type_type"
                        :symbol="item.point[0].point_type_symbol"
                        :color="item.point[0].point_type_color"
                        :is_display="true"
                        :outlined_box="false"
                        :size="28"
                      />
                    </div>
                    <v-icon v-else :color="site.color"
                      >mdi-ticket-confirmation-outline</v-icon
                    >
                  </div>
                  <div class="pr-2">
                    <p
                      class="mb-0"
                      style="font-size: 12px; color: #ffffff; line-height: 1"
                      v-snip="{ lines: 2 }"
                    >
                      {{ getConditionEntryPass(item) }}
                    </p>
                  </div>
                </div>
              </div>
            </v-card>
          </div>
        </v-slide-item>
      </v-slide-group>
    </v-sheet>
    <div
      class="d-flex d-xxl-none d-xl-none d-lg-none d-md-none d-sm-none justify-center"
      style="gap: 4px"
    >
      <div
        v-if="dataItems.length > 1"
        class="dot"
        :style="{
          backgroundColor: positionSlider == 'start' ? site.color : '#C8C8C8',
        }"
      ></div>
      <div
        v-if="dataItems.length > 2"
        class="dot"
        :style="{
          backgroundColor: positionSlider == 'middle' ? site.color : '#C8C8C8',
        }"
      ></div>
      <div
        v-if="dataItems.length > 1"
        class="dot"
        :style="{
          backgroundColor: positionSlider == 'end' ? site.color : '#C8C8C8',
        }"
      ></div>
    </div>
  </v-container>
</template>

<script>
import moment from "moment";
import PointSymbol from "./point/point-symbol.vue";

export default {
  components: { PointSymbol },
  props: ["dataItems", "site", "typeActivity"],
  data() {
    return {
      model: 0,
      dialogDetail: false,
      item: "",
      keyComponent: 0,
      qrcode_key: "",
      positionSlider: "start",
    };
  },

  methods: {
    redirectTo(item) {
      this.$router.push({
        name: "gamification-detail",
        params: { id: item.id },
      });
    },
    commaPoint(value) {
      // comma point number to baht
      if (value == 0) {
        return "0";
      } else if (value) {
        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      }
    },
    onTouchLeft() {
      const v_slide_group__content =
        this.$refs.vsheet?.$el?.getElementsByClassName(
          "v-slide-group__content"
        );
      if (v_slide_group__content?.length > 0) {
        const count = this.dataItems.length;
        const widthAvg = 300;
        const element = v_slide_group__content[0];
        const transform = getComputedStyle(element).transform;
        if (transform) {
          const match = transform.match(/matrix\((.*)\)/);
          if (match) {
            const values = match[1].split(",");
            const translateX = parseFloat(values[4].trim());
            if (count > 1) {
              const translateXAbs = Math.abs(translateX);
              if (translateXAbs >= widthAvg * (count - 1)) {
                this.positionSlider = "end";
              } else if (translateXAbs >= widthAvg / 2) {
                this.positionSlider = "middle";
                if (count == 2) {
                  this.positionSlider = "end";
                }
              }
            }
          }
        }
      }
    },
    onTouchRight() {
      const v_slide_group__content =
        this.$refs.vsheet?.$el?.getElementsByClassName(
          "v-slide-group__content"
        );
      if (v_slide_group__content?.length > 0) {
        const count = this.dataItems.length;
        const widthAvg = 300;
        const element = v_slide_group__content[0];
        const transform = getComputedStyle(element).transform;
        if (transform) {
          const match = transform.match(/matrix\((.*)\)/);
          if (match) {
            const values = match[1].split(",");
            const translateX = parseFloat(values[4].trim());
            if (count > 1) {
              const translateXAbs = Math.abs(translateX);
              if (translateXAbs <= widthAvg / 1.5) {
                this.positionSlider = "start";
              } else if (
                translateXAbs <=
                widthAvg * (count - 1) + widthAvg / 1.5
              ) {
                this.positionSlider = "middle";
                if (count == 2) {
                  this.positionSlider = "end";
                }
              }
            }
          }
        }
      }
    },

    getConditionEntryPass(param) {
      let text = `-`;
      const input_type = param.input_type;
      const point = param.point;
      const reward_name = param.reward_name;
      if (input_type == "point") {
        if (Array.isArray(point) && point.length > 0 && point[0].point) {
          text = `${this.commaPoint(point[0].point)} ${
            point[0].point_type_name
          }`;
        }
      } else if (input_type == "reward" && reward_name) {
        text = `${reward_name}`;
      }
      return text;
    },
    checkConditionEntryPassFree(param) {
      let isFree = false;
      const input_type = param.input_type;
      const point = param.point;
      if (input_type == "point") {
        if (
          !point ||
          (Array.isArray(point) && point.length > 0 && !point[0].point)
        ) {
          isFree = true;
        }
      }
      return isFree;
    },
  },
  computed: {
    innerHeight() {
      const height = window.innerHeight;
      return height - 100;
    },
  },
  filters: {
    formatDate: function (value) {
      if (!value) return "-";
      return moment(value).format("D MMMM YY");
    },
  },
};
</script>

<style scoped>
.card-container {
  position: relative;
}

.bottomleft {
  position: absolute;
  bottom: 8px;
}
.container1 {
  position: relative;
}
.btn-close {
  position: absolute;
  z-index: 888;
}
.text-over-image {
  background-color: blue;
  color: white;
  font-weight: bold;
  margin-right: 0;
  float: right;
}
.close-button {
  background-color: rgba(0, 0, 0, 0.25);
}

.description-box {
  width: 100%;
  height: 80px;
  padding: 8px;
  position: absolute;
  bottom: 0px;
  left: 0px;
  background-color: #00000080;
}

.description-label {
  line-height: 1.3;
  text-overflow: ellipsis;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: #c8c8c8;
}
</style>
